<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
  <div class="download">
    <div class="swiperBox">
      <!-- <swiper :options="swiperOption" class="swiper">
        <swiper-slide v-for="(item, index) in invitation_img" :key="index" :class="{active:index === 0, shadow:true}">
          <div @click="detail(item.id)">
            <div class="banner">
              <img :src="item" alt="">
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination" slot="pagination"></div> -->
      <img class="swiperImg" :src="newImgUrl" alt="">
    </div>
    <div id="leftTabBox" class="tabBox slide">
    </div>
    <div class="copy invite">
      <div>邀请码: <span id="tar_text">{{code}}</span></div>
      <div id="copys"
              v-clipboard:copy="code"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError">
        复制邀请码
      </div>
    </div>
    <div class="text">
      长按此处也可以复制，用于激活APP使用资格
    </div>
    <a href="javascript:" class="forbid" v-show="!cut" @click="goDownload()">下载APP</a>
    <a href="javascript:" class="allow" v-show="cut" @click="showTips()">下载APP(请先复制邀请码)</a>
    <a href="javascript:" class="allow" v-show="codes">无效的code</a>
    <div class="show" v-show = 'shows'>
      复制成功
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'
import axios from 'axios'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'download',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      codes: false,
      cut: true,
      shows: false,
      datas: {},
      invitation_img: [],
      newImgUrl: '',
      code: '',
      downloadUrl: '',
      swiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        // width: 100%,
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          progressbarOpposite: true,
          bulletElement: 'li',
          dynamicBullets: false,
          dynamicMainBullets: 2,
          hideOnClick: false,
          clickable: true
        }
      }
    }
  },
  methods: {
    onCopy (e) {
      let that = this
      this.cut = false
      this.shows = true
      window.setTimeout(refreshCount, 1000)
      function refreshCount () {
        that.shows = false
        console.log(that.shows)
      }
    },
    goDownload () {
      window.location.href = this.downloadUrl
    },
    showTips () {
      Toast({
        message: '请先复制邀请码',
        className: 'coln'
      })
    },
    onError (e) {
    },
    deviceType () {
      let u = navigator.userAgent
      // android终端
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      // ios终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isiOS) {
        return 'ios'
      } else if (isAndroid) {
        return 'android'
      } else {
        return 'other'
      }
    }
  },
  mounted () {
    let code = this.GLOBAL.getQueryString('code')
    if (!code) {
      this.codes = true
    }
    axios.get(this.GLOBAL.apiUrl + '/api/w1/share/download/?code=' + code).then((res) => {
    // axios.get(this.GLOBAL.apiUrl + '/api/w1/share/download/?code=' + 'MTkzXzE%3D').then((res) => {
      if (res.data.code === 0) {
        this.datas = res.data.data
        this.invitation_img = res.data.data.invitation_img
        this.newImgUrl = res.data.data.invitation_img[0]
        this.code = res.data.data.invite_code
        const downloadType = res.data.data.download_type
        const deviceType = this.deviceType()
        if (downloadType === 'two-in-one') {
          this.downloadUrl = res.data.data.two_in_one
        } else {
          if (deviceType === 'ios') {
            this.downloadUrl = res.data.data.ios
          } else {
            this.downloadUrl = res.data.data.android
          }
        }
        document.title = res.data.data.title
      }
    })
  }
}
</script>
<style>
  .swiper-slide {
    width: 80%;
  }
  .swiper-pagination-clickable .swiper-pagination-bullet{
    transform: scale(1);
  }
  .swiper-pagination{
    bottom: 0.2rem;
  }
  .swiper-pagination{
    left: 50%;
    transform: translateX(-50%);
    width: 200px
  }
  .swiper-pagination li{
    margin: 0 5px;
  }
  .swiper-pagination-bullet{
    opacity: 1;
    background-color: rgba(0,0,0,0.4);
  }
  .swiper-pagination-bullet-active{
    background-color: #007aff;
  }
  .swiper-pagination{
    width: 200px;
  }
  .mint-toast is-placemiddle{
    width: 4rem;
  }
  .mint-swipe{
    width: 100%;
  }
  .mint-swipe-items-wrap{
    width: 100%;
  }
  .coln{
    width: 2.8rem;
    height: 1.1rem;
    line-height: 1.1rem;
    /*padding: 0.3rem 0!important;*/
    margin-top: -0.2rem;
    background-color: rgba(0,0,0,0.6);
    color: #fff;
    /*background-color: #000;*/
    font-size: 0.32rem;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0!important;
  }
</style>
<style scoped>
  .download{
    margin-top: 0px;
  }
  .active{
    /*margin-left: 30px;*/
  }
  .swiperBox {
    /*width: 100%;*/
    position: relative;
  }
  .swiperBox .swiper {
    /*margin-top: 0.5rem;*/
  }
  .swiperBox .swiperImg{
    width: 100%;
    height: 6.8rem;
  }
  /* .swiperBox .bgc {
    width: 100%;
    height: 2rem;
    position: absolute;
    top: -0.5rem;
    left: 0;
  }
  .swiperBox .bgc img {
    width: 100%;
    height: 100%;
  }
  .swiperBox .items {
    position: absolute;
    width: 0.80rem;
    height: 1.7rem;
    top: 1.14rem;
    right: 0.16rem;
  }
  .swiperBox .items .piece {
    width: 0.8rem;
    height: 0.8rem;
    color: red;
    font-size: 0.26rem;
    text-align: center;
    background-color: #fff;
    opacity: 0.7;
    border-radius: 4px;
  }
  .swiperBox .items .piece span {
    display: block;
  }
  .swiperBox .items .img {
    width: 0.8rem;
    height: 0.8rem;
    top: 0.1rem;
    position: relative;
  }
  .swiperBox .items .img img {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  } */
  .banner {
    width: 100%;
    background-color: #f7f7f7;
  }
  .banner img {
    display:block;
    width:100%;
  }
  .copy{
    position: relative;
    width: 5rem;
    display: flex;
    margin: -0.35rem auto 0.36rem auto;
    text-align: center;
    line-height: 0.88rem;
    font-size: 0.28rem;
    color: #FF5847;
    height: 0.88rem;
    z-index: 3;
  }
  .copy div:nth-child(1){
    background-color: #FEE9E5;
    flex: 3;
    /*border: 1px solid #fff;*/
    border-top-left-radius:0.44rem;
    /*border-top-right-radius:2em;*/
    /*border-bottom-right-radius:2em;*/
    border-bottom-left-radius:0.44rem;
  }
  .copy div:nth-child(2){
    flex: 2;
    background-color: #FF6A6A;
    color: #fff;
    border-top-right-radius:0.44rem;
    border-bottom-right-radius:0.44rem;
  }
  .text{
    text-align: center;
    font-size: 0.24rem;
    color: #666666;
  }
  .show{
    color: #fff;
    position: fixed;
    top: 273px;
    width: 120px;
    height: 40px;
    font-size: 13px;
    text-align: center;
    line-height: 40px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px;
    background-color: black;
    opacity: 0.7;
    /*display: none;*/
    z-index: 999;
  }
  a{
    width: 5.6rem;
    background: linear-gradient(270deg,rgba(246,61,54,1),rgba(248,123,100,1));
    box-shadow:0px 0.03rem 0.06rem 0px rgba(210,35,0,0.37);
    box-sizing: border-box;
    font-family:PingFang-SC-Regular;
    font-weight:500;
    font-size: 0.3rem;
    text-align: center;
    line-height: 0.88rem;
    margin: 0.6rem auto 0 auto;
    border-radius: 0.44rem;
    text-decoration:none;
    color: #fff;
  }
  .forbid{
    display: block;
    height: 0.88rem;
  }
  .allow{
    background-color: #ff7b7e;
    display: block;
    height: 0.88rem;
  }
  .tabBox .hd{ height:40px; line-height:40px; padding:0 10px; font-size:20px; background:#f4f4f4; border-bottom:1px solid #F5AB38; position:relative;  }
  .tabBox .hd ul{ position:absolute; height:41px; top:0; overflow:hidden;  }
  .tabBox .hd ul li{ float:left; padding:0 10px; color:#666;  }
  .tabBox .hd ul .on{ border:2px solid #F5AB38; border-bottom-color:#fff; background:#fff; color:#CF7F21;   }
  .tabBox .bd ul{ padding:10px 0 10px 10px;  }
  .tabBox .bd li{ height:33px; line-height:33px;   }
  .tabBox .bd li a{ color:#666; }
</style>



// WEBPACK FOOTER //
// src/components/download.vue